const routes = [
  {
    routeName: 'WelcomePage',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/WelcomePage/WelcomePage').default).as('WelcomePage');
        callback();
      }, 'WelcomePage');
    }
  },
  {
    routeName: 'ContactForm',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/ContactForm/ContactForm').default).as('ContactForm');
        callback();
      }, 'ContactForm');
    }
  },
  {
    routeName: 'NewsletterRegistration',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/NewsletterRegistration/NewsletterRegistration').default).as('NewsletterRegistration');
        callback();
      }, 'NewsletterRegistration');
    }
  },
  {
    routeName: 'SearchAutocomplete',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/SearchAutocomplete/SearchAutocomplete').default).as('SearchAutocomplete');
        callback();
      }, 'SearchAutocomplete');
    }
  },
  {
    routeName: 'SearchResults',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/SearchResults/SearchResults').default).as('SearchResults');
        callback();
      }, 'SearchResults');
    }
  },
  {
    routeName: 'JobSearch',
    load: (container, callback) => {
      require.ensure(['./pages/JobSearch/JobSearch'], (require) => {
        container.register(require('./pages/JobSearch/JobSearch').default).as('JobSearch');
        callback();
      }, 'JobSearch');
    }
  },
  {
    routeName: 'GasConnectionNew',
    load: (container, callback) => {
      require.ensure(['./pages/GasConnectionNew/GasConnectionNew'], (require) => {
        container.register(require('./pages/GasConnectionNew/GasConnectionNew').default).as('GasConnectionNew');
        callback();
      }, 'GasConnectionNew');
    }
  },
  {
    routeName: 'GasConnection',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/GasConnection/GasConnection').default).as('GasConnection');
        callback();
      }, 'GasConnection');
    }
  },
  {
    routeName: 'RenewalGasConnection',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/RenewalGasConnection/RenewalGasConnection').default).as('RenewalGasConnection');
        callback();
      }, 'RenewalGasConnection');
    }
  },
  {
    routeName: 'RegistrationLibraryEvent',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/RegistrationLibraryEvent/RegistrationLibraryEvent').default).as('RegistrationLibraryEvent');
        callback();
      }, 'RegistrationLibraryEvent');
    }
  },
  {
    routeName: 'ChecklistEnergyStorage',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/ChecklistEnergyStorage/ChecklistEnergyStorage').default).as('ChecklistEnergyStorage');
        callback();
      }, 'ChecklistEnergyStorage');
    }
  },
  {
    routeName: 'ApplicationCitizenEnergyPrice',
    load: (container, callback) => {
      require.ensure([], (require) => {
        container.register(require('./pages/ApplicationCitizenEnergyPrice/ApplicationCitizenEnergyPrice').default).as('ApplicationCitizenEnergyPrice');
        callback();
      }, 'ApplicationCitizenEnergyPrice');
    }
  },
  {
    routeName: 'GasDecommission',
    load: (container, callback) => {
      require.ensure(['./pages/GasDecommission/GasDecommission'], (require) => {
        container.register(require('./pages/GasDecommission/GasDecommission').default).as('GasDecommission');
        callback();
      }, 'GasDecommission');
    }
  },
  {
    routeName: 'MunicipalityEasyContact',
    load: (container, callback) => {
      require.ensure(['./pages/MunicipalityEasyContact/MunicipalityEasyContact'], (require) => {
        container.register(require('./pages/MunicipalityEasyContact/MunicipalityEasyContact').default).as('MunicipalityEasyContact');
        callback();
      }, 'MunicipalityEasyContact');
    }
  },
  {
    routeName: 'MunicipalityContact',
    load: (container, callback) => {
      require.ensure(['./pages/MunicipalityContact/MunicipalityContact'], (require) => {
        container.register(require('./pages/MunicipalityContact/MunicipalityContact').default).as('MunicipalityContact');
        callback();
      }, 'MunicipalityContact');
    }
  },
  {
    routeName: 'GridConnection',
    load: (container, callback) => {
      require.ensure(['./pages/GridConnection/GridConnection'], (require) => {
        container.register(require('./pages/GridConnection/GridConnection').default).as('GridConnection');
        callback();
      }, 'GridConnection');
    }
  },
  {
    routeName: 'MultiHouse',
    load: (container, callback) => {
      require.ensure(['./pages/MultiHouse/MultiHouse'], (require) => {
        container.register(require('./pages/MultiHouse/MultiHouse').default).as('MultiHouse');
        callback();
      }, 'MultiHouse');
    }
  },
  {
    routeName: 'PowerShares',
    load: (container, callback) => {
      require.ensure(['./pages/PowerSharesForm/PowerShares'], (require) => {
        container.register(require('./pages/PowerSharesForm/PowerShares').default).as('PowerShares');
        callback();
      }, 'PowerShares');
    }
  },
  {
    routeName: 'ShutOffDevice',
    load: (container, callback) => {
      require.ensure(['./pages/ShutOffDevice/ShutOffDevice'], (require) => {
        container.register(require('./pages/ShutOffDevice/ShutOffDevice').default).as('ShutOffDevice');
        callback();
      }, 'ShutOffDevice');
    }
  },
  {
    routeName: 'GoogleMaps',
    load: (container, callback) => {
      require.ensure(['./pages/GoogleMaps/GoogleMaps'], (require) => {
        container.register(require('./pages/GoogleMaps/GoogleMaps').default).as('GoogleMaps');
        callback();
      }, 'GoogleMaps');
    }
  },
  {
    routeName: 'ContactSearch',
    load: (container, callback) => {
      require.ensure(['./pages/ContactSearch/ContactSearch'], (require) => {
        container.register(require('./pages/ContactSearch/ContactSearch').default).as('ContactSearch');
        callback();
      }, 'ContactSearch');
    }
  },
  {
    routeName: 'HighVoltageRegister',
    load: (container, callback) => {
      require.ensure(['./pages/HighVoltageRegister/HighVoltageRegister'], (require) => {
        container.register(require('./pages/HighVoltageRegister/HighVoltageRegister').default).as('HighVoltageRegister');
        callback();
      }, 'HighVoltageRegister');
    }
  },
  {
    routeName: 'OnlineConnection',
    load: (container, callback) => {
      require.ensure(['./pages/OnlineConnection/OnlineConnection'], (require) => {
        container.register(require('./pages/OnlineConnection/OnlineConnection').default).as('OnlineConnection');
        callback();
      }, 'OnlineConnection');
    }
  },
  {
    routeName: 'Pipeline',
    load: (container, callback) => {
      require.ensure(['./pages/Pipeline/Pipeline'], (require) => {
        container.register(require('./pages/Pipeline/Pipeline').default).as('Pipeline');
        callback();
      }, 'Pipeline');
    }
  },
  {
    routeName: 'OnlineDecommission',
    load: (container, callback) => {
      require.ensure(['./pages/OnlineDecommission/OnlineDecommission'], (require) => {
        container.register(require('./pages/OnlineDecommission/OnlineDecommission').default).as('OnlineDecommission');
        callback();
      }, 'OnlineDecommission');
    }
  },
  {
    routeName: 'EwiRegistration',
    load: (container, callback) => {
      require.ensure(['./pages/EwiRegistration/EwiRegistration'], (require) => {
        container.register(require('./pages/EwiRegistration/EwiRegistration').default).as('EwiRegistration');
        callback();
      }, 'EwiRegistration');
    }
  },
  {
    routeName: 'EwiProductComparison',
    load: (container, callback) => {
      require.ensure(['./pages/EwiProductComparison/EwiProductComparison'], (require) => {
        container.register(require('./pages/EwiProductComparison/EwiProductComparison').default).as('EwiProductComparison');
        callback();
      }, 'EwiProductComparison');
    }
  },
  {
    routeName: 'EwiDirectDebit',
    load: (container, callback) => {
      require.ensure(['./pages/EwiDirectDebit/EwiDirectDebit'], (require) => {
        container.register(require('./pages/EwiDirectDebit/EwiDirectDebit').default).as('EwiDirectDebit');
        callback();
      }, 'EwiDirectDebit');
    }
  },
  {
    routeName: 'EwiMeterReading',
    load: (container, callback) => {
      require.ensure(['./pages/EwiMeterReading/EwiMeterReading'], (require) => {
        container.register(require('./pages/EwiMeterReading/EwiMeterReading').default).as('EwiMeterReading');
        callback();
      }, 'EwiMeterReading');
    }
  },
  {
    routeName: 'EwiCancellation',
    load: (container, callback) => {
      require.ensure(['./pages/EwiCancellation/EwiCancellation'], (require) => {
        container.register(require('./pages/EwiCancellation/EwiCancellation').default).as('EwiCancellation');
        callback();
      }, 'EwiCancellation');
    }
  },
  {
    routeName: 'EwiReregistration',
    load: (container, callback) => {
      require.ensure(['./pages/EwiReregistration/EwiReregistration'], (require) => {
        container.register(require('./pages/EwiReregistration/EwiReregistration').default).as('EwiReregistration');
        callback();
      }, 'EwiReregistration');
    }
  },
  {
    routeName: 'EwiDirectDebit',
    load: (container, callback) => {
      require.ensure(['./pages/EwiDirectDebit/EwiDirectDebit'], (require) => {
        container.register(require('./pages/EwiDirectDebit/EwiDirectDebit').default).as('EwiDirectDebit');
        callback();
      }, 'EwiDirectDebit');
    }
  },
  {
    routeName: 'Hausanschluss',
    load: (container, callback) => {
      require.ensure(['./pages/HausanschlussForm/HausanschlussForm'], (require) => {
        container.register(require('./pages/HausanschlussForm/HausanschlussForm').default).as('Hausanschluss');
        callback();
      }, 'Hausanschluss');
    }
  },
  {
    routeName: 'EInternetAccess',
    load: (container, callback) => {
      require.ensure(['./pages/EInternetAccess/EInternetAccess'], (require) => {
        container.register(require('./pages/EInternetAccess/EInternetAccess').default).as('EInternetAccess');
        callback();
      }, 'EInternetAccess');
    }
  },
  {
    routeName: 'ETransmissionPath',
    load: (container, callback) => {
      require.ensure(['./pages/ETransmissionPath/ETransmissionPath'], (require) => {
        container.register(require('./pages/ETransmissionPath/ETransmissionPath').default).as('ETransmissionPath');
        callback();
      }, 'ETransmissionPath');
    }
  },
  {
    routeName: 'CustomerAdvisoryBoard',
    load: (container, callback) => {
      require.ensure(['./pages/CustomerAdvisoryBoard/CustomerAdvisoryBoard'], (require) => {
        container.register(require('./pages/CustomerAdvisoryBoard/CustomerAdvisoryBoard').default).as('CustomerAdvisoryBoard');
        callback();
      }, 'CustomerAdvisoryBoard');
    }
  },
  {
    routeName: 'EnerOpt',
    load: (container, callback) => {
      require.ensure(['./pages/EnerOpt/EnerOpt'], (require) => {
        container.register(require('./pages/EnerOpt/EnerOpt').default).as('EnerOpt');
        callback();
      }, 'EnerOpt');
    }
  },
  {
    routeName: 'AvaconGasConnectionCampaign',
    load: (container, callback) => {
      require.ensure(['./pages/AvaconGasConnectionCampaign/AvaconGasConnectionCampaign'], (require) => {
        container.register(require('./pages/AvaconGasConnectionCampaign/AvaconGasConnectionCampaign').default).as('AvaconGasConnectionCampaign');
        callback();
      }, 'AvaconGasConnectionCampaign');
    }
  },
  {
    routeName: 'NewsOverview',
    load: (container, callback) => {
      require.ensure(['./pages/Darksite/NewsOverview'], (require) => {
        container.register(require('./pages/Darksite/NewsOverview').default).as('NewsOverview');
        callback();
      }, 'NewsOverview');
    }
  },
  {
    routeName: 'TenderOffersTable',
    load: (container, callback) => {
      require.ensure(['./pages/TenderOffersTable/TenderOffersTable'], (require) => {
        container.register(require('./pages/TenderOffersTable/TenderOffersTable').default).as('TenderOffersTable');
        callback();
      }, 'TenderOffersTable');
    }
  },
  {
    routeName: 'ZipContactSearch',
    load: (container, callback) => {
      require.ensure(['./pages/ZipContactSearch/ZipContactSearch'], (require) => {
        container.register(require('./pages/ZipContactSearch/ZipContactSearch').default).as('ZipContactSearch');
        callback();
      }, 'ZipContactSearch');
    }
  },
  {
    routeName: 'SearchMarketplaceChangeLastDateByZipcode',
    load: (container, callback) => {
      require.ensure(['./pages/SearchMarketplaceChangeLastDateByZipcode/SearchMarketplaceChangeLastDateByZipcode'], (require) => {
        container.register(require('./pages/SearchMarketplaceChangeLastDateByZipcode/SearchMarketplaceChangeLastDateByZipcode').default).as('SearchMarketplaceChangeLastDateByZipcode');
        callback();
      }, 'SearchMarketplaceChangeLastDateByZipcode');
    }
  },
  {
    routeName: 'HouseConnectionCalculator',
    load: (container, callback) => {
      require.ensure(
        ['./pages/HouseConnectionCalculator/HouseConnectionCalculator'],
        (require) => {
          container.register(require('./pages/HouseConnectionCalculator/HouseConnectionCalculator').default).as('HouseConnectionCalculator');
          callback();
        },
        'HouseConnectionCalculator'
      );
    }
  },
  {
    routeName: 'RenewalElectricityConnection',
    load: (container, callback) => {
      require.ensure(['./pages/RenewalElectricityConnection/RenewalElectricityConnection'], (require) => {
        container.register(require('./pages/RenewalElectricityConnection/RenewalElectricityConnection').default).as('RenewalElectricityConnection');
        callback();
      }, 'RenewalElectricityConnection');
    }
  },
  {
    routeName: 'NewMeterGatewayType',
    load: (container, callback) => {
      require.ensure(['./pages/NewMeterGatewayType/NewMeterGatewayType'], (require) => {
        container.register(require('./pages/NewMeterGatewayType/NewMeterGatewayType').default).as('NewMeterGatewayType');
        callback();
      }, 'NewMeterGatewayType');
    }
  },
  {
    routeName: 'EarlyCommissionImsys',
    load: (container, callback) => {
      require.ensure(['./pages/EarlyCommissionImsys/EarlyCommissionImsys'], (require) => {
        container.register(require('./pages/EarlyCommissionImsys/EarlyCommissionImsys').default).as('EarlyCommissionImsys');
        callback();
      }, 'EarlyCommissionImsys');
    }
  },
  {
    routeName: 'MuseumTourRegistration',
    load: (container, callback) => {
      require.ensure(['./pages/MuseumTourRegistration/MuseumTourRegistration'], (require) => {
        container.register(require('./pages/MuseumTourRegistration/MuseumTourRegistration').default).as('MuseumTourRegistration');
        callback();
      }, 'MuseumTourRegistration');
    }
  },
  {
    routeName: 'CoronaSponsoringForm',
    load: (container, callback) => {
      require.ensure(['./pages/CoronaSponsoringForm/CoronaSponsoringForm'], (require) => {
        container.register(require('./pages/CoronaSponsoringForm/CoronaSponsoringForm').default).as('CoronaSponsoringForm');
        callback();
      }, 'CoronaSponsoringForm');
    }
  },
  {
    routeName: 'CustomerDataForm',
    load: (container, callback) => {
      require.ensure(['./pages/CustomerDataForm/CustomerDataForm'], (require) => {
        container.register(require('./pages/CustomerDataForm/CustomerDataForm').default).as('CustomerDataForm');
        callback();
      }, 'CustomerDataForm');
    }
  },
  {
    routeName: 'DynamicForm',
    load: (container, callback) => {
      require.ensure(['./pages/DynamicForm/DynamicForm'], (require) => {
        container.register(require('./pages/DynamicForm/DynamicForm').default).as('DynamicForm');
        callback();
      }, 'DynamicForm');
    }
  }
];

export default routes;
